import { render, staticRenderFns } from "./MonthlyBalance.vue?vue&type=template&id=4838e450"
import script from "./MonthlyBalance.vue?vue&type=script&lang=js"
export * from "./MonthlyBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports